import { MedewerkersOpStation } from "@/entities/medewerkers-op-station";
import { Badge, Dot, Icon } from "@/shared/components";
import { cn } from "@/shared/utils";
import { statusMap } from "../../constants";

type MedewerkersStationStatusProps = {
    station: MedewerkersOpStation;
    toonBeschikbareVossen?: boolean;
};

export function MedewerkersStationStatus({ station, toonBeschikbareVossen }: MedewerkersStationStatusProps) {
    return (
        <div>
            {station.veilig ? (
                <MedewerkersStationStatusTekst station={station} toonBeschikbareVossen={toonBeschikbareVossen} />
            ) : (
                <Badge variant="red-subtle" className="gap-1">
                    <Icon name="error" size="xs" /> Onveilig
                </Badge>
            )}
        </div>
    );
}

type MedewerkersStationStatusTekstProps = {
    station: MedewerkersOpStation;
    toonBeschikbareVossen?: boolean;
};

function MedewerkersStationStatusTekst({ station, toonBeschikbareVossen = true }: MedewerkersStationStatusTekstProps) {
    if (station.status === "NietAangevraagd" && !toonBeschikbareVossen) return null;
    switch (station.status) {
        case "NietAangevraagd":
            return <p>{station.aantalBeschikbareVossen} beschikbaar</p>;
        case "AanvraagLoopt":
        case "VosIngezet":
        case "GeenVosInzetbaar":
        case "Gestopt":
            return (
                <p className="flex items-center gap-2">
                    {statusMap[station.status].label} <Dot variant={statusMap[station.status].dotVariant} />
                </p>
            );
    }
}

type MedewerkersStationStatusIconProps = {
    station: MedewerkersOpStation;
    className?: string;
};

export function MedewerkersStationStatusIcon({ station, className }: MedewerkersStationStatusIconProps) {
    return (
        <div className={cn(className)}>
            {station.status === "AanvraagLoopt" && <Icon name="loader" size="xs" className="text-content-info" />}
            {station.status === "VosIngezet" && <Icon name="check-circle" size="xs" className="text-content-success" />}
            {(station.status === "GeenVosInzetbaar" || station.status === "Gestopt") && (
                <Icon name="denied-circle" size="xs" className="text-content-placeholder" />
            )}
        </div>
    );
}
